<div #datePickerContainer class="ax-date-picker__container" [ngClass]="setContainerClasses()" [tabIndex]="tabIndex">
    <input type="text" class="ax-date-picker__input" [(ngModel)]="firstDateValue" [placeholder]="placeholder" (ngModelChange)="firstDateChanged($event)">
    @if (hasSelectedValue) {
        <i class="fa-light fa-circle-xmark ax-date-picker__clear" (click)="clear($event)"></i>
    }
    <i class="fa-solid fa-calendar-days ax-date-picker__toggle" (click)="toggle($event)"></i>
</div>